import { useCallback } from 'react';
import React from 'react';

import { useDispatch } from 'react-redux';

import closeTokens from '@amzn/meridian-tokens/base/icon/close-small';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Sheet from '@amzn/meridian/sheet';
import { applyFilters, resetFilters, setIsAdvancedFilterSheetOpen } from 'src/store/placementOverviewPageSlice';
import { useAppSelector } from 'src/store/store';

import MultipleDaysInCategoryDropdown from './multipleDaysInCategoryDropdown';
import MultipleJobDropwdown from './multipleJobDropdown';
import MultipleJobTypeDropwdown from './multipleJobTypeDropdown';
import MultiplePlacementTypeDropdown from './multiplePlacementTypeDropdown';
import MultipleShiftDropdown from './multipleShiftDropdown';
import MultipleSiteDropdown from './multipleSiteDropdown';
import StartAndEndDateInput from './startAndEndDateInput';

const AdvancedFilterSheet = () => {
  const { isAdvancedFilterSheetOpen } = useAppSelector((state) => state.placementOverviewPage);
  const dispatch = useDispatch();
  const close = useCallback(() => {
    dispatch(setIsAdvancedFilterSheetOpen(false));
  }, [dispatch]);

  const reset = useCallback(() => dispatch(resetFilters()), [dispatch]);

  const apply = useCallback(() => {
    dispatch(applyFilters());
    dispatch(setIsAdvancedFilterSheetOpen(false));
  }, [dispatch]);

  return (
    <Sheet type="overlay" side="end" open={isAdvancedFilterSheetOpen} onClose={close}>
      <Column spacing="500" height={250}>
        <Row widths={['grid-10', 'grid-2']}>
          <Heading level={4}>Filter placements</Heading>
          <Button onClick={close} type="icon">
            <Icon tokens={closeTokens}>Close sheet</Icon>
          </Button>
        </Row>
        <Column spacing="400">
          <MultipleJobDropwdown />
          <MultipleShiftDropdown />
          <MultipleDaysInCategoryDropdown />
          <MultiplePlacementTypeDropdown />
          <MultipleSiteDropdown />
          <MultipleJobTypeDropwdown />
          <StartAndEndDateInput />
          <Row alignmentHorizontal="center">
            <Button type="secondary" onClick={reset}>
              Reset
            </Button>
            <Button onClick={apply}>Apply</Button>
          </Row>
        </Column>
      </Column>
    </Sheet>
  );
};

export default AdvancedFilterSheet;
